import { createApp } from 'vue';
import './styles/tokens.css';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router/index.js';
import { useAuthStore } from '@/stores/auth';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);

// Token is already restored from localStorage by the store; confirm it in the background.
const authStore = useAuthStore();
if (authStore.token) {
  authStore.verifySession().then((valid) => {
    if (!valid) router.push('/login');
  });
}

app.mount('#app');
